import { Navigate, useParams } from "react-router-dom";
import { Hardware } from "./hardware/Hardware";
import { Logistics } from "./logistics/Logistics";
import { Openings } from "./openings/Openings";
import { Pricing } from "./pricing/Pricing";
import { ManagerLockProvider } from "./ProjectActions";
import { Misc } from "./misc/Misc";
import { Div10 } from "./div10/Div10";
import { FreeformChanges } from "./freeformchanges/FreeformChanges";
import { PriceLookupHotkeyPopup } from "../../priceLookup/PriceLookupHotkeyPopup";
import { Keying2 } from "./keying2/Keying2";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ShopDrawing() { return /*#__PURE__*/ _jsxs(ManagerLockProvider, { children: [/*#__PURE__*/ _jsx(Inner, {}), /*#__PURE__*/ _jsx(PriceLookupHotkeyPopup, {})] }); }
function Inner() {
    const params = useParams();
    switch (params.workspace) {
        case "hardware": return /*#__PURE__*/ _jsx(Hardware, {});
        case "logistics": return /*#__PURE__*/ _jsx(Logistics, {});
        case "release": // the release screen now lives in logistics as a view
            return /*#__PURE__*/ _jsx(Navigate, { to: `/project/${params.project}/shop-drawing/logistics?view=release`, replace: true });
        case "pricing": return /*#__PURE__*/ _jsx(Pricing, {});
        case "changes": return /*#__PURE__*/ _jsx(FreeformChanges, {});
        case "misc": return /*#__PURE__*/ _jsx(Misc, {});
        case "keying": return /*#__PURE__*/ _jsx(Keying2, {});
        case "div10": return /*#__PURE__*/ _jsx(Div10, {});
        default: return /*#__PURE__*/ _jsx(Openings, {});
    }
}
